var tiles = require('@code-dot-org/maze').tiles;
var Direction = tiles.Direction;

var blockUtils = require('../block_utils');
var levelBase = require('../level_base');

var msg = require('./locale');

//TODO: Fix hacky level-number-dependent toolbox.
var toolbox = function (page, level) {
  var template;
  // Must use switch, since browserify only works on requires with literals.
  switch (page) {
    case 1:
      template = require('./toolboxes/karel1.xml.ejs');
      break;
    case 2:
      template = require('./toolboxes/karel2.xml.ejs');
      break;
    case 3:
      template = require('./toolboxes/karel3.xml.ejs');
      break;
  }
  return template({level: level});
};

//TODO: Fix hacky level-number-dependent startBlocks.
var startBlocks = function (page, level) {
  return require('./karelStartBlocks.xml.ejs')({
    page: page,
    level: level,
  });
};

// This tests for and creates the "move_forward" block.
var MOVE_FORWARD = {
  test: function (block) {
    return block.type === 'maze_moveForward';
  },
  type: 'maze_moveForward',
};

// This tests for and creates the "dig" block.
var DIG = {test: 'dig', type: 'maze_dig'};

// This tests for and creates the "fill" block.
var FILL = {test: 'fill', type: 'maze_fill'};

// This tests for and creates the "controls_repeat" block.
var REPEAT = {
  test: function (block) {
    return block.type === 'controls_repeat';
  },
  type: 'controls_repeat',
  titles: {TIMES: '???'},
};

// This tests for and creates the "controls_repeat_ext" block.
var REPEAT_EXT = {
  test: function (block) {
    return block.type === 'controls_repeat_ext';
  },
  type: 'controls_repeat_ext',
};

// This tests for and creates the "controls_for" block.
var CONTROLS_FOR = {
  test: function (block) {
    return block.type === 'controls_for';
  },
  type: 'controls_for',
};

// This tests for and creates the "variables_get" block.
var VARIABLES_GET = {
  test: function (block) {
    return block.type === 'variables_get';
  },
  type: 'variables_get',
  titles: {VAR: 'i'},
};

// This tests for and creates the "maze_turn" block turning left.
var TURN_LEFT = {
  test: 'turnLeft',
  type: 'maze_turn',
  titles: {DIR: 'turnLeft'},
};

// This tests for and creates the "maze_turn" block turning right.
var TURN_RIGHT = {
  test: 'turnRight',
  type: 'maze_turn',
  titles: {DIR: 'turnRight'},
};

// This tests for and creates the "maze_untilBlocked" block.
var UNTIL_BLOCKED = {
  test: 'while (Maze.isPathForward',
  type: 'maze_untilBlocked',
};

// This tests for and creates the "maze_untilBlockedOrNotClear" block with the option "pilePresent" selected.
var WHILE_OPT_PILE_PRESENT = {
  test: 'while (Maze.pilePresent',
  type: 'maze_untilBlockedOrNotClear',
  titles: {DIR: 'pilePresent'},
};

// This tests for and creates the "maze_untilBlockedOrNotClear" block with the option "holePresent" selected.
var WHILE_OPT_HOLE_PRESENT = {
  test: 'while (Maze.holePresent',
  type: 'maze_untilBlockedOrNotClear',
  titles: {DIR: 'holePresent'},
};

// This tests for and creates the "maze_untilBlockedOrNotClear" block with the option "isPathForward" selected.
var WHILE_OPT_PATH_AHEAD = {
  test: 'while (Maze.isPathForward',
  type: 'maze_untilBlockedOrNotClear',
  titles: {DIR: 'isPathForward'},
};

// This tests for and creates the "karel_if" block with the option "pilePresent" selected.
var IF_OPT_PILE_PRESENT = {
  test: 'if (Maze.pilePresent',
  type: 'karel_if',
  titles: {DIR: 'pilePresent'},
};

// This tests for and creates the "karel_if" block with the option "holePresent" selected.
var IF_OPT_HOLE_PRESENT = {
  test: 'if (Maze.holePresent',
  type: 'karel_if',
  titles: {DIR: 'holePresent'},
};

// This tests for and creates the "karel_ifElse" block.
var IF_ELSE = {test: '} else {', type: 'karel_ifElse'};

// This tests for and creates the "fill num" block.
var fill = function (num) {
  return {
    test: function (block) {
      return block.getFieldValue('NAME') === msg.fillN({shovelfuls: num});
    },
    type: 'procedures_callnoreturn',
    titles: {NAME: msg.fillN({shovelfuls: num})},
  };
};

// This tests for and creates the "remove num" blcok.
var remove = function (num) {
  return {
    test: function (block) {
      return block.getFieldValue('NAME') === msg.removeN({shovelfuls: num});
    },
    type: 'procedures_callnoreturn',
    titles: {NAME: msg.removeN({shovelfuls: num})},
  };
};

// This tests for and creates the "avoid the cow and remove 1" block.
var AVOID_OBSTACLE_AND_REMOVE = {
  test: function (block) {
    return block.getFieldValue('NAME') === msg.avoidCowAndRemove();
  },
  type: 'procedures_callnoreturn',
  titles: {NAME: msg.avoidCowAndRemove()},
};

// This tests for and creates the "remove piles" block.
var REMOVE_PILES = {
  test: function (block) {
    return block.getFieldValue('NAME') === msg.removeStack({shovelfuls: 4});
  },
  type: 'procedures_callnoreturn',
  titles: {NAME: msg.removeStack({shovelfuls: 4})},
};

// This tests for and creates the "fill holes" block.
var FILL_HOLES = {
  test: function (block) {
    return block.getFieldValue('NAME') === msg.fillStack({shovelfuls: 2});
  },
  type: 'procedures_callnoreturn',
  titles: {NAME: msg.fillStack({shovelfuls: 2})},
};

module.exports = {
  // Formerly page 1
  '1_1': {
    instructionsImportant: true,
    toolbox: toolbox(1, 1),
    startBlocks: startBlocks(1, 1),
    ideal: 6,
    requiredBlocks: [[MOVE_FORWARD], [DIG]],
    scale: {
      snapRadius: 2.0,
    },
    map: [
      [0, 0, 0, 0, 0, 1, 1, 1],
      [0, 1, 1, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [2, 1, 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_2': {
    toolbox: toolbox(1, 2),
    startBlocks: startBlocks(1, 2),
    ideal: 4,
    requiredBlocks: [[MOVE_FORWARD], [FILL]],
    map: [
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 1, 1, 0, 0, 0, 0],
      [0, 1, 2, 1, 0, 0, 0, 0],
      [0, 1, 1, 1, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 1, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, -2, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_3': {
    toolbox: toolbox(1, 3),
    startBlocks: startBlocks(1, 3),
    ideal: 4,
    requiredBlocks: [[MOVE_FORWARD], [DIG], [REPEAT]],
    map: [
      [1, 1, 1, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 1, 1, 1, 0],
      [0, 0, 0, 0, 1, 2, 1, 0],
      [0, 0, 0, 0, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.SOUTH,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 10, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_4': {
    toolbox: toolbox(1, 4),
    ideal: 5,
    requiredBlocks: [[MOVE_FORWARD], [DIG], [TURN_LEFT], [REPEAT]],
    map: [
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 2, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_5': {
    toolbox: toolbox(1, 5),
    startBlocks: startBlocks(1, 5),
    ideal: 5,
    requiredBlocks: [[MOVE_FORWARD], [FILL], [REPEAT], [UNTIL_BLOCKED]],
    scale: {
      stepSpeed: 2,
    },
    map: [
      [1, 1, 0, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [2, 1, 1, 1, 1, 1, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, -5, -5, -5, -5, -5, 0, 0],
    ],
  },

  '1_6': {
    toolbox: toolbox(1, 6),
    ideal: 4,
    requiredBlocks: [
      [MOVE_FORWARD],
      [DIG],
      [WHILE_OPT_PILE_PRESENT, REPEAT, WHILE_OPT_PATH_AHEAD],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [1, 1, 0, 1, 1, 0, 1, 1],
      [1, 1, 0, 2, 1, 0, 1, 1],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [1, 1, 0, 1, 1, 0, 1, 1],
      [1, 1, 0, 1, 1, 0, 1, 1],
    ],
    startDirection: Direction.SOUTH,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_7': {
    toolbox: toolbox(1, 7),
    startBlocks: startBlocks(1, 7),
    ideal: 5,
    requiredBlocks: [
      [TURN_RIGHT],
      [MOVE_FORWARD],
      [FILL],
      [WHILE_OPT_HOLE_PRESENT],
    ],
    scale: {
      stepSpeed: 2,
    },
    map: [
      [1, 1, 0, 0, 0, 0, 1, 1],
      [1, 1, 1, 0, 0, 0, 0, 1],
      [0, 1, 1, 2, 0, 0, 0, 0],
      [0, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 1, 1, 1, 0],
      [1, 0, 0, 0, 0, 1, 1, 1],
      [1, 1, 0, 0, 0, 0, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, -18, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_8': {
    toolbox: toolbox(1, 8),
    ideal: 4,
    requiredBlocks: [[MOVE_FORWARD], [FILL], [WHILE_OPT_PATH_AHEAD, REPEAT]],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [2, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, -1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_9': {
    toolbox: toolbox(1, 9),
    ideal: 8,
    requiredBlocks: [
      [MOVE_FORWARD],
      [DIG],
      [WHILE_OPT_PATH_AHEAD, REPEAT],
      [TURN_LEFT],
    ],
    scale: {
      stepSpeed: 2.5,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 1, 1, 0, 1, 0, 0, 0],
      [0, 1, 1, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [2, 1, 1, 1, 1, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 1, 1, 1, 1, 0, 0, 0],
    ],
  },

  '1_10': {
    toolbox: toolbox(1, 10),
    startBlocks: startBlocks(1, 10),
    ideal: 5,
    requiredBlocks: [
      [MOVE_FORWARD],
      [DIG],
      [IF_OPT_PILE_PRESENT],
      [UNTIL_BLOCKED, REPEAT],
    ],
    scale: {
      stepSpeed: 2.5,
    },
    map: [
      [1, 1, 0, 0, 0, 0, 1, 1],
      [1, 1, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [2, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 1, 1],
      [1, 1, 0, 0, 0, 0, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 0, 0, 1, 1, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '1_11': {
    toolbox: toolbox(1, 11),
    startBlocks: startBlocks(1, 11),
    ideal: 7,
    requiredBlocks: [
      [MOVE_FORWARD],
      [DIG],
      [FILL],
      [IF_OPT_PILE_PRESENT],
      [IF_OPT_HOLE_PRESENT],
      [UNTIL_BLOCKED, REPEAT],
    ],
    scale: {
      stepSpeed: 2.5,
    },
    map: [
      [1, 1, 0, 0, 0, 0, 1, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [2, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 1, 0, 0, 0, 0, 1, 1],
      [1, 1, 1, 0, 0, 1, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, -1, 0, 0, -1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  // Formerly page 2

  '2_1': {
    instructionsImportant: true,
    toolbox: toolbox(2, 1),
    startBlocks: startBlocks(2, 1),
    ideal: null,
    requiredBlocks: [],
    recommendedBlocks: [[MOVE_FORWARD], [DIG], [FILL], [TURN_LEFT, TURN_RIGHT]],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, 0, 0, 0],
      [2, 1, 1, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 0, 0, 0, 0],
      [1, -1, 1, 0, 0, 0, 0, 0],
      [1, -1, 1, 0, 0, 0, 0, 0],
    ],
  },

  '2_2': {
    toolbox: toolbox(2, 2),
    startBlocks: startBlocks(2, 2),
    ideal: 6,
    requiredBlocks: [],
    recommendedBlocks: [[MOVE_FORWARD], [fill(5)]],
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 1, 1, 0],
      [0, 1, 0, 0, 0, 0, 1, 0],
      [0, 1, 0, 2, 1, 0, 1, 0],
      [0, 1, 0, 1, 1, 0, 1, 0],
      [0, 1, 0, 0, 0, 0, 1, 0],
      [0, 1, 1, 1, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, -5, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '2_3': {
    toolbox: toolbox(2, 3),
    startBlocks: startBlocks(2, 3),
    ideal: 8,
    requiredBlocks: [],
    recommendedBlocks: [[MOVE_FORWARD], [fill(5)], [UNTIL_BLOCKED, REPEAT]],
    scale: {
      stepSpeed: 2,
    },
    map: [
      [0, 1, 1, 1, 1, 1, 1, 0],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [0, 2, 1, 1, 1, 1, 1, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, -5, -5, -5, -5, -5, 0],
    ],
  },

  '2_4': {
    toolbox: toolbox(2, 4),
    startBlocks: startBlocks(2, 4),
    ideal: 13,
    requiredBlocks: [],
    recommendedBlocks: [
      [DIG],
      [REPEAT],
      [remove(7)],
      [MOVE_FORWARD],
      [TURN_LEFT],
      [TURN_RIGHT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [1, 1, 1, 1, 0, 0, 1, 1],
      [1, 1, 1, 0, 0, 1, 1, 1],
      [1, 1, 0, 0, 1, 1, 1, 0],
      [1, 0, 0, 1, 1, 1, 0, 0],
      [0, 0, 1, 1, 1, 0, 0, 1],
      [0, 1, 2, 1, 0, 0, 1, 1],
      [1, 1, 1, 0, 0, 1, 1, 1],
      [1, 1, 0, 0, 1, 1, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 7, 0, 0],
      [0, 0, 0, 0, 7, 0, 0, 0],
      [0, 0, 0, 7, 0, 0, 0, 0],
      [0, 0, 7, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '2_5': {
    toolbox: toolbox(2, 5),
    startBlocks: startBlocks(2, 5),
    ideal: 8,
    requiredBlocks: [],
    recommendedBlocks: [[DIG], [REPEAT], [remove(6)], [MOVE_FORWARD]],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [1, 2, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 0, 1, 1, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 6, 0, 6, 0, 6, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '2_6': {
    toolbox: toolbox(2, 6),
    startBlocks: startBlocks(2, 6),
    ideal: 11,
    requiredBlocks: [],
    recommendedBlocks: [
      [remove(8)],
      [fill(8)],
      [MOVE_FORWARD],
      [UNTIL_BLOCKED, REPEAT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [2, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 1, 0],
      [0, 0, 0, 0, 1, 1, 1, 0],
      [0, 0, 0, 0, 1, 1, 1, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [8, 0, 0, 0, 0, 0, 0, -8],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '2_7': {
    toolbox: toolbox(2, 7),
    startBlocks: startBlocks(2, 7),
    ideal: 11,
    requiredBlocks: [],
    recommendedBlocks: [[TURN_LEFT], [MOVE_FORWARD], [TURN_RIGHT], [DIG]],
    map: [
      [1, 1, 0, 0, 0, 1, 1, 1],
      [1, 1, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 1, 0, 0, 0],
      [0, 0, 2, 4, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '2_8': {
    toolbox: toolbox(2, 8),
    startBlocks: startBlocks(2, 8),
    ideal: 13,
    requiredBlocks: [],
    recommendedBlocks: [[REPEAT], [AVOID_OBSTACLE_AND_REMOVE]],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [2, 4, 1, 4, 1, 4, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 0, 1, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  '2_9': {
    toolbox: toolbox(2, 9),
    startBlocks: startBlocks(2, 9),
    ideal: 14,
    requiredBlocks: [],
    recommendedBlocks: [
      [REMOVE_PILES],
      [MOVE_FORWARD],
      [UNTIL_BLOCKED, REPEAT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [2, 1, 1, 1, 1, 1, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 0, 0],
      [1, 1, 1, 1, 1, 1, 0, 0],
      [1, 1, 1, 1, 1, 1, 0, 0],
      [1, 1, 1, 1, 1, 1, 0, 0],
    ],
  },

  '2_10': {
    toolbox: toolbox(2, 10),
    startBlocks: startBlocks(2, 10),
    ideal: 27,
    requiredBlocks: [],
    recommendedBlocks: [
      [REMOVE_PILES],
      [MOVE_FORWARD],
      [FILL_HOLES],
      [IF_OPT_PILE_PRESENT, IF_ELSE],
      [UNTIL_BLOCKED, REPEAT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [2, 1, 1, 1, 1, 1, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 0, 1, 0, 0, 1, 0, 0],
      [1, 0, 1, 0, 0, 1, 0, 0],
      [1, -1, 1, -1, -1, 1, -1, 0],
      [1, -1, 1, -1, -1, 1, -1, 0],
    ],
  },

  // Page 3 to Debug

  debug_seq_1: {
    instructionsImportant: true,
    toolbox: toolbox(3, 1),
    startBlocks: startBlocks(3, 1),
    ideal: 8,
    requiredBlocks: [[MOVE_FORWARD], [DIG], [FILL], [TURN_LEFT], [TURN_RIGHT]],
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 4, 1, 1, 0, 0, 0],
      [0, 0, 2, 1, 4, 0, 0, 0],
      [1, 1, 0, 0, 0, 1, 1, 0],
      [1, 1, 0, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, -1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_seq_2: {
    toolbox: toolbox(3, 2),
    startBlocks: startBlocks(3, 2),
    ideal: 7,
    requiredBlocks: [[MOVE_FORWARD], [DIG], [TURN_LEFT]],
    map: [
      [1, 1, 0, 0, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 2, 1, 1, 0, 1, 0],
      [0, 0, 1, 1, 1, 0, 1, 0],
      [0, 0, 1, 1, 1, 0, 0, 0],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 1, 0, 0, 0, 0, 0, 1],
    ],
    startDirection: Direction.SOUTH,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_repeat: {
    toolbox: toolbox(3, 3),
    startBlocks: startBlocks(3, 3),
    ideal: 12,
    requiredBlocks: [
      [MOVE_FORWARD],
      [DIG],
      [TURN_LEFT],
      [TURN_RIGHT],
      [REPEAT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 1, 1, 1, 1, 0, 1],
      [1, 0, 1, 2, 1, 1, 0, 1],
      [1, 0, 1, 1, 1, 1, 0, 1],
      [1, 0, 1, 1, 1, 1, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
    ],
    startDirection: Direction.SOUTH,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 5, 0, 0, 0],
      [0, 0, 0, 0, 0, 7, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_while: {
    toolbox: toolbox(3, 4),
    startBlocks: startBlocks(3, 4),
    ideal: 5,
    requiredBlocks: [
      [MOVE_FORWARD],
      [REPEAT],
      [FILL],
      [WHILE_OPT_HOLE_PRESENT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 1, 1, 0],
      [0, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 1, 0, 0, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 2, 1, 1, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, -15, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_if: {
    toolbox: toolbox(3, 5),
    startBlocks: startBlocks(3, 5),
    ideal: 8,
    requiredBlocks: [
      [MOVE_FORWARD],
      [TURN_LEFT],
      [TURN_RIGHT],
      [REPEAT],
      [DIG],
      [IF_OPT_PILE_PRESENT, WHILE_OPT_PILE_PRESENT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 1, 1, 0],
      [0, 0, 0, 0, 1, 1, 0, 1],
      [0, 0, 0, 1, 1, 0, 1, 1],
      [0, 0, 1, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 1, 1, 0, 1],
      [2, 1, 0, 1, 1, 0, 1, 1],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_if_else: {
    toolbox: toolbox(3, 6),
    startBlocks: startBlocks(3, 6),
    ideal: 10,
    requiredBlocks: [
      [MOVE_FORWARD],
      [TURN_LEFT],
      [TURN_RIGHT],
      [REPEAT],
      [DIG],
      [FILL],
      [IF_ELSE, IF_OPT_HOLE_PRESENT],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 1, 1, 0, 1],
      [0, 0, 0, 1, 1, 0, 1, 1],
      [0, 0, 1, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 1, 1, 0, 1],
      [1, 1, 0, 1, 1, 0, 1, 1],
      [1, 0, 1, 1, 0, 1, 1, 0],
      [0, 1, 1, 0, 1, 1, 0, 0],
      [2, 1, 0, 1, 1, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, -1],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, -1, 0, 0, 0],
      [0, 0, 0, -1, 0, 0, 0, 0],
      [0, 0, 1, 0, 0, 0, 0, 0],
      [0, -1, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_function_1: {
    toolbox: toolbox(3, 7),
    startBlocks: startBlocks(3, 7),
    ideal: 8,
    requiredBlocks: [[MOVE_FORWARD], [TURN_LEFT], [REPEAT], [DIG]],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 0],
      [0, 0, 2, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 0],
      [0, 0, 1, 0, 0, 1, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_function_2: {
    toolbox: toolbox(3, 8),
    startBlocks: startBlocks(3, 8),
    ideal: 17,
    requiredBlocks: [
      [MOVE_FORWARD],
      [TURN_LEFT],
      [REPEAT],
      [DIG],
      [FILL],
      [levelBase.call(msg.fillSquare())],
      [levelBase.call(msg.removeSquare())],
    ],
    scale: {
      stepSpeed: 3,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [1, 0, 1, 0, 0, 1, 0, 1],
      [2, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 1, 1, 0, 0, -1, -1, -1],
      [1, 0, 1, 0, 0, -1, 0, -1],
      [1, 1, 1, 0, 0, -1, -1, -1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  debug_function_3: {
    toolbox: toolbox(3, 9),
    startBlocks: startBlocks(3, 9),
    ideal: 12,
    requiredBlocks: [
      [MOVE_FORWARD],
      [REPEAT_EXT],
      [DIG],
      [CONTROLS_FOR],
      [levelBase.callWithArg(msg.removePile(), msg.heightParameter())],
      [VARIABLES_GET],
    ],
    scale: {
      stepSpeed: 2,
    },
    map: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 0, 0],
      [0, 1, 1, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [1, 2, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 1, 1, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 2, 3, 4, 5, 6, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },

  bee_1: {
    toolbox: blockUtils.createToolbox(
      '\
      <block type="maze_moveForward"></block>\
      <block type="maze_turn"><title name="DIR">turnLeft</title></block>\
      <block type="maze_turn"><title name="DIR">turnRight</title></block>\
      <block type="maze_nectar"></block>\
      <block type="maze_honey"></block>\
      <block type="math_number"><title name="NUM">0</title></block>\
      <block type="bee_ifNectarAmount"></block>\
      <block type="bee_ifTotalNectar"></block>\
      <block type="bee_ifFlower"></block>\
      <block type="bee_ifOnlyFlower"></block>\
      <block type="bee_whileNectarAmount"></block>'
    ),
    startBlocks: startBlocks(1, 1),
    requiredBlocks: [],
    scale: {
      snapRadius: 2.0,
    },
    honeyGoal: 1,
    // nectarGoal: 2,
    step: true,
    map: [
      [0, 0, 0, 0, 0, 1, 1, 1],
      [0, 1, 1, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 1, 1, 1],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [2, 'P', 1, 1, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
      [0, 0, 1, 1, 0, 0, 0, 0],
    ],
    startDirection: Direction.EAST,
    initialDirt: [
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 3, -1, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0],
    ],
  },
};
